import { inject, Injectable } from '@angular/core';
import { EDeliverableType } from '@enums/campaign.enum';
import { IDeliverableConfig } from '../deliverable-list.interface';
import { TextDeliverableService } from '../shared/text-deliverable/text-deliverable.service';
import { AudioTrackingComponent } from './audio-tracking.component';

@Injectable({
  providedIn: 'root',
})
export class AudioTrackingService {
  private readonly textDeliverableService = inject(TextDeliverableService);

  public getConfig(): IDeliverableConfig {
    return this.textDeliverableService.getConfig({
      component: AudioTrackingComponent,
      defaultNameTranslationKey: 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.audioTrackingDeliverable.title',
      deliverableType: EDeliverableType.audioTracking,
    });
  }
}
